import { render, staticRenderFns } from "./ClientsDns.vue?vue&type=template&id=edd276f0&"
import script from "./ClientsDns.vue?vue&type=script&lang=js&"
export * from "./ClientsDns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports